<div class="weekly-work-time-container px-5 pt-3">
    <div class="row">
        <div class="col-12 d-flex" [ngClass]="isWeeklyWorkHoursExceeded() ? 'exceeded-max-hours' : 'header-item'">
            <span class="pb-2" translate="WEEKLY_WORK_TABLE_HEADER_LABEL"></span>
            <span class="ms-auto">
                : {{ totalCommittedInMinutes() | formatDuration }}
                @if (totalInProgressInMinutes() > 0) {
                    <span class="in-progress-marker" [title]="inProgressLabel" [attr.aria-label]="inProgressLabel">
                        (+{{ totalInProgressInMinutes() | formatDuration }})
                    </span>
                }
            </span>
        </div>
    </div>

    <div class="row mb-3">
        <div class="col-12 weekly-work-time-list">
            @for (day of weeklyWorkdays(); track day.workDate) {
                <span class="work-time-date" [ngClass]="{ exceededMaxHours: dayExceedsMaxHours(day) }">
                    {{ formatDate(day.workDate) }}
                </span>
                <span class="work-time-colon" [ngClass]="{ exceededMaxHours: dayExceedsMaxHours(day) }">:</span>
                <span class="work-time-value" [ngClass]="{ exceededMaxHours: dayExceedsMaxHours(day) }">
                    {{ day.committedInMinutes | formatDuration }}
                    @if (day.inProgressInMinutes > 0) {
                        <span class="in-progress-marker" [title]="inProgressLabel" [attr.aria-label]="inProgressLabel">
                            (+{{ day.inProgressInMinutes | formatDuration }})
                        </span>
                    }
                </span>
            }
        </div>
    </div>

    <div class="status-bar">
        <div
            [ngClass]="statusBar()?.type ?? ''"
            class="footer-design d-flex justify-content-center align-items-center position-relative overflow-hidden"
        >
            {{ statusBar()?.text ?? '' }}
        </div>
    </div>
</div>
